import { useEffect, useState } from "react";
import axios from "axios";
import appConfig from "config/appConfig";
import { verifyTokenExpire } from "middleware/verifyToken";
import { ToastBottomEnd } from "views/components/Toast";
import {
  toastEditErrorMessageConfig,
  toastEditSuccessMessageConfig,
} from "config/toastConfig";

const defaultErrors = {
  coefs: [],
  delays: [],
  limit: [],
};

// Transforme la valeur en tableau sécurisé [ "val1", "val2" ]
const formatArrayField = (value) => {
  if (Array.isArray(value) && value.length > 0) {
    return value.map(item => String(item));
  }
  if (typeof value === "string" || typeof value === "number") {
    return [String(value)];
  }
  return [""];
};

// Helper pour trouver une clé dans un objet, même imbriqué
const extractField = (obj, keys) => {
  if (!obj) return null;
  for (const key of keys) {
    if (obj[key] !== undefined && obj[key] !== null) return obj[key];
  }
  if (obj.data) return extractField(obj.data, keys);
  return null;
};

export const useCoefficientForm = (initialData) => {
  const [formData, setFormData] = useState({
    coefs: [""],
    delays: [""],
    limit: 0,
  });

  const [errors, setErrors] = useState(defaultErrors);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    

    if (initialData) {
      const rawCoefs = extractField(initialData, ["coefs", "coef", "coefficients"]);
      const rawDelays = extractField(initialData, ["delays", "delai", "delais"]);
      const rawLimit = extractField(initialData, ["limit"]) || 0;

      setFormData({
        coefs: formatArrayField(rawCoefs),
        delays: formatArrayField(rawDelays),
        limit: rawLimit,
      });
    }
  }, [initialData]);

  const updateField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (!verifyTokenExpire()) return;

    try {
      setIsSubmitting(true);
      setErrors(defaultErrors);

      const payload = {
        coefs: formData.coefs.filter((val) => val !== ""),
        delays: formData.delays.filter((val) => val !== ""),
        limit: formData.limit || 0,
      };

      await axios.put(
        `${appConfig.apiDomaine}/configurations/relance`,
        payload
      );

      ToastBottomEnd.fire(toastEditSuccessMessageConfig());
    } catch (error) {
      const errorData = error.response?.data?.error || {};
      const errors = {
        coefs: [],
        delays: [],
        limit: [],
      };

      Object.entries(errorData).forEach(([key, messages]) => {
        const [field, index] = key.split(".");
        if (Array.isArray(errors[field]) && index !== undefined) {
          errors[field][Number(index)] = messages;
        } else if (key in errors) {
          errors[key] = messages;
        }
      });

      setErrors({ ...defaultErrors, ...errors });
      ToastBottomEnd.fire(toastEditErrorMessageConfig());
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    formData,
    errors,
    isSubmitting,
    updateField,
    handleSubmit,
  };
};